import clsx from 'clsx';
import { Card } from './Card.jsx';
import { Skeleton } from './Skeleton.jsx';

export function KpiCard({ label, value, sub, loading = false, className }) {
  return (
    <Card className={clsx('p-5 transition-all hover:border-border-strong', className)}>
      <p className="text-xs font-medium text-ink-muted">{label}</p>
      {loading ? (
        <Skeleton className="mt-2 h-8 w-24" />
      ) : (
        <p className="animate-slide-in-up mt-2 text-3xl font-semibold tracking-tight text-ink">{value}</p>
      )}
      {sub && !loading && <p className="mt-1 text-xs text-ink-muted">{sub}</p>}
    </Card>
  );
}
